import React from "react";
import financeApiService from "../../../../services/financeApiService";
import ChampLibreDossier from "./ChampLibreDossier";

// LS-717 — compte comptable du dossier (compte de charge 612… créé dans le
// logiciel comptable à réception de l'échéancier). Champ libre, saisi dès
// "Accord reçu" et corrigeable, comme le n° de contrat financeur ; affiché à
// la place de la référence FIN-… dans la liste des demandes.
const CompteComptable = ({ demandeUuid, compteComptable, canEdit, onSaved }) => (
  <ChampLibreDossier
    libelle="Compte comptable"
    libelleTitre="compte comptable"
    valeur={compteComptable}
    canEdit={canEdit}
    placeholder="Ex. 612450"
    enregistrer={(compte) =>
      financeApiService.saisirCompteComptable(demandeUuid, compte)
    }
    messageSucces="Compte comptable enregistré."
    messageErreur="L'enregistrement du compte comptable a échoué."
    onSaved={onSaved}
  />
);

export default CompteComptable;
